import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { DayBackground, NightBackground } from './styles/themes';
import GlobalStyle from './styles/GlobalStyle';
import ChatWindow from './components/ChatWindow';
import FontSelector from './components/FontSelector';
import Login from './components/Login';
import AccountPage from './components/AccountPage';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";








const SidebarTitle = styled.h3`
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
`;



function App() {
  const [isNight, setIsNight] = useState(false);
  const [selectedFont, setSelectedFont] = useState('Vazir');

  const [messages, setMessages] = useState([]);

  const [isLoggedIn, setIsLoggedIn] = useState(
    window.localStorage.getItem("loggedIn") === "true"
  );



  
  

  const Background = isNight ? NightBackground : DayBackground;
  const googleClientId = "850430605841-2cg8uuhpp817ojbj8qim28ivt6tfl2qh.apps.googleusercontent.com";

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Router>
        <Routes>
          <Route path="/" element={
            isLoggedIn ? (
              <Background>
                <GlobalStyle />
                <ChatWindow
                  isNight={isNight}
                  setIsNight={setIsNight}
                  selectedFont={selectedFont}
                  setSelectedFont={setSelectedFont}
                  messages={messages}
                  setMessages={setMessages}
                />
              </Background>
            ) : (
              <Login />
            )
          } />
          <Route path="/account" element={<AccountPage />} />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
